import React from "react";
import { styled } from "styled-components";
import { Link } from 'gatsby'

const Container = styled.button`
  border-radius: 38px;
  font-family: Montserrat, sans-serif;
  font-size: 22px;
  padding: 22px 55px;
  background-color: ${(props) => (props.active ? "#000" : "#fff")};
  border: none;
  color: ${(props) => (props.active ? "#fff" : "#000")};
  border: 2px solid #000;
  font-weight: normal;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  opacity: 0.4;
  pointer-events: none;
  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
    pointer-events: none;
  }
  a {
    text-decoration: none;
    color: ${(props) => (props.active ? "#fff" : "#000")};
  }
`;

const ButtonDisabled = ({ children, link, active, ...rest }) => {


  if (link) {
    return (
      <Container {...rest} active={active}>
        <Link to={link}>{children}</Link>
      </Container>
    );
  } else {
    return (
      <Container {...rest} active={active}>
        {children}
      </Container>
    );
  }
};

export default ButtonDisabled;
